import { Call, Location, Sms } from "iconsax-react";
import { routes } from "../../routers/routes";
import { ContactBoxList, IconLinkList } from "../../types/CommonComponents";
import { FooterDetailType } from "../../types/Layout";

export const ContactListData: ContactBoxList[] = [
  { icon: <Call className="iconsax" />, title: "Contact Us", text: "(60) 11-6291-4913", text1: 'ccautoworldsdnbhd@gmail.com' },
  // { icon: <Sms className="iconsax" />, title: "Email", text: "general.info@gmail.com" },
  { icon: <Location className="iconsax" />, title: "Location", text: "E-G-32, BLOCK E, Taipan 2, Jalan PJU 1A/3, Ara Damansara, 47301, Petaling Jaya, Selangor." },
];

export const SocialMediaData: IconLinkList[] = [
  {
    url: "https://wa.me/+601162914913",
    icon: "ri-whatsapp-line",
  },
  {
    url: "https://www.facebook.com/profile.php?id=100082301858224",
    icon: "ri-facebook-line",
  },
  {
    url: "https://www.instagram.com/ccautoworld/?hl=en",
    icon: "ri-instagram-line",
  },
  {
    url: "https://www.tiktok.com/@ccautoworld7",
    icon: "ri-tiktok-fill",
  },
];

export const FooterDetailData: FooterDetailType[] = [
  {
    id: 1,
    title: "Follow Us",
    links: [
      { title: "WhatsApp", url: "https://wa.me/+601162914913" },
      { title: "Facebook", url: "https://www.facebook.com/profile.php?id=100082301858224" },
      { title: "Instagram", url: "https://www.instagram.com/ccautoworld/?hl=en" },
      { title: "TikTok", url: "https://www.tiktok.com/@ccautoworld7" },
    ],
  },
  {
    id: 2,
    title: "Cars",
    links: [
      { title: "Inventory", url: routes.Car.Listing.CarLeftList },
    ],
  },
  {
    id: 3,
    title: "Services",
    links: [
      { title: "Sell Your Car", url: routes.Pages.Other.ContactUs2 },
      { title: "Consign With Us", url: routes.Pages.Other.ConsignWithUs },
      { title: "JPJ Services", url: routes.Pages.Other.JPJ },
      { title: "Loan Calculator", url: routes.Car.Other.CarLoanCalculator },
    ],
  },
  {
    id: 4,
    title: "About",
    links: [
      { title: "About Us", url: routes.Pages.Other.AboutUs1 },
      { title: "Our Journey", url: routes.Pages.Other.OurJourney },
      { title: "Contact Us", url: routes.Pages.Other.ContactUs1 },
    ],
  },
];

export const FooterDescription: string[] = ["Specialising in premium pre-owned vehicles. Buy with assurance, sell with ease. vehicles, with transparent pricing and hassle-free service."];

export const FooterClassMap: { [key: string]: string } = {
  "car-2": "car2-footer",
  "job-2": "dark-footer-section section-t-space",
  "property-2": "property2-footer",
};
